module.exports = __webpack_public_path__ + "img/Angela.22c6223e.jpg";